import Vue from 'vue'
import Router from 'vue-router'
import StartView from './views/StartView.vue'

Vue.use(Router)

export let initialized = false;

export default new Router({
  routes: [
    {
      path: '/',
      name: 'startview',
      component: StartView,
      beforeEnter: (to, from, next) => {
        initialized = true;
        next();
      },
    },
    {
      path: '/fahrt',
      name: 'fahrtview',
      beforeEnter: (to, from, next) => {
        if(initialized) next();
        else next('/');
      },
      component: () => import(/* webpackChunkName: "about" */ './views/FahrtView.vue')
    },
    {
      path: '/tickets',
      name: 'anzahlview',
      beforeEnter: (to, from, next) => {
        if(initialized) next();
        else next('/');
      },
      component: () => import(/* webpackChunkName: "about" */ './views/AnzahlView.vue')
    },
    {
      path: '/daten',
      name: 'datenview',
      beforeEnter: (to, from, next) => {
        if(initialized) next();
        else next('/');
      },
      component: () => import(/* webpackChunkName: "about" */ './views/DatenView.vue')
    },
    {
      path: '/bestaetigung',
      name: 'bestaetigungview',
      beforeEnter: (to, from, next) => {
        if(initialized) next();
        else next('/');
      },
      component: () => import(/* webpackChunkName: "about" */ './views/BestaetigungView.vue')
    },
    {
      path: '/fehler',
      name: 'fehlerview',
      beforeEnter: (to, from, next) => {
        if(initialized) next();
        else next('/');
      },
      component: () => import(/* webpackChunkName: "about" */ './views/FehlerView.vue')
    },
    {
      path: '/bearbeiten',
      name: 'editview',
      beforeEnter: (to, from, next) => {
        if(initialized) next();
        else next('/');
      },
      component: () => import(/* webpackChunkName: "about" */ './views/EditView.vue')
    },
    {
      path: '/bezahlen',
      name: 'bezahlview',
      beforeEnter: (to, from, next) => {
        if(initialized) next();
        else next('/');
      },
      component: () => import(/* webpackChunkName: "about" */ './views/CheckoutView.vue')
    }
  ]
})
